//Install
import React, { Component } from "react";
//Install
import { ReactComponent as P9824U } from "../../../Media/Brand/003.svg";

//Element
class S058JF extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "S0u16d C96Q4r vR05U6 d721Vx y763h1" },
            //Element
            React.createElement(P9824U, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default S058JF;